<form [formGroup]="form_translate" class="kt-form kt-form--label-right live-translate">
    {{ 'core.live_translation.agent_language' | t:'Agent language' }} 
        <ng-select [items]="translations_languages"
            bindLabel="name"
            bindValue="code"
            labelForId="language_agent"
            formControlName="language_agent">
        </ng-select>
    
        <span [inlineSVG]="'Navigation/Up-down.svg'" class="bi-direction svg-primary" [title]="'core.live_translation.two_way_translation' | t:'Two-way Translation'"></span>

        {{ 'core.live_translation.visitor_language' | t:'Visitor language' }}
        <span [hidden]="!(is_loading_detect_language$ | async)" class="kt-spinner kt-spinner--v2 kt-spinner--sm kt-spinner--brand"></span>

        <ng-select [items]="translations_languages" 
            bindLabel="name"
            bindValue="code"
            labelForId="language_visitor"
            formControlName="language_visitor">
        </ng-select>  

        <div class="kt-align-right kt-margin-t-10">
            <span class="kt-margin-r-10"><a href="javascript:void(0)" (click)="popover.close(); stop_translation()" class="kt-link kt-font-bold">{{ 'core.live_translation.turn_off' | t:'Turn Off' }}</a> {{ 'core.live_translation.or' | t:'or' }}</span>
            <button class="btn btn-brand" (click)="popover.close(); apply_translation()" type="button">{{ 'common.apply' | t:'Apply' }}</button>		
        </div>

</form>